import React from 'react'

const Footer = () => {
    const currentYear = new Date().getFullYear();
  return (
    <div className='Footer_Container' >
    <span>&copy; {currentYear} CSFA. All rights reserved.</span>
    <a target="_blank" href="/PrivacyPolicy" className='Footer_Url' >Privacy Policy</a>
</div>
  )
}

export default Footer